export enum InstallmentFrequency {
  Monthly = 'monthly',
  Yearly = 'yearly',
}

export enum BillingType {
  Brokerage = 'brokerage',
  Direct = 'direct',
}

export type CheckoutData = {
  underwriter: string
  underwriterSlug: string
  product: string
  installmentFrequency: InstallmentFrequency
  downpayment: number
  installmentPayment: number
  collectPayment: boolean
  billingType: BillingType
  brokerage: string
}
